.expired {
  text-decoration: line-through;
}

.filled {
  --mtdsc-chip-border-color: transparent;
}

.outlined {
  --mtdsc-chip-background: transparent;
}

.mainText {
  --mtdsc-chip-color: var(--mtds-color-main-text-default);
}
